import styled from 'styled-components'
import Flex from 'components/Flex'
import { COLORS } from 'theme'
import Button from 'components/Button/index'
import { Collapse, Radio, Divider, Col, Calendar , Checkbox, Tag} from 'antd'
import { LeftOutlined, RightOutlined } from '@ant-design/icons'
export const SectionWrapper = styled(Flex)`
  width: 100%;
  border: 1px solid ${COLORS.PAGE_BORDER};
  box-shadow: 0px 2px 6px rgba(123, 97, 255, 0.15);
  margin: 30px 100px 0px 100px;
  border-radius: 10px;
  overflow: scroll;
  background: ${COLORS.WHITE};
  &::-webkit-scrollbar {
    display: none;
  }
  @media only screen and (max-device-width: 767px) {
    margin: 10px;
  }
   @media only screen and (min-width: 1200px) and (max-width: 1300px) {
    margin: 30px 20px 20px 20px;
  }  
  @media only screen and (min-width: 768px )  and  (max-width : 1200px){
    margin: 10px;
  }
`

export const TopHeader = styled(Flex)`
  padding: 20px 25px;
  position: relative;
  width: 100%;
`
export const ExtraPadding = styled.div`
  padding-left: 40px;
`

export const TopHeading = styled(Flex)`
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 28px;
  color: ${COLORS.GREY_P_100};
`

export const TopRightFlex = styled(Flex)`
  gap: 15px;
`
export const SmallButtons = styled(Button.Default)`
  background: ${COLORS.WHITE};
  padding: 9px;
  > div {
    margin-left: 0;
  }
`
export const CardRow = styled(Flex)`
  padding: 0 25px 15px 25px;
  gap: 20px;
`
export const TabDiv = styled.div`
  padding: 0px 20px 20px 20px;
`

export const FilterCollapse = styled(Collapse)`
  background-color: #fafafb !important;
  margin-right: 5px;

  .ant-collapse-header {
    position: relative;
    display: flex;
    flex-wrap: nowrap;
    align-items: flex-start;
    padding: 10px !important;
    font-weight: 600;
    border-radius: 10px !important;
    border-radius: 5px;
    color: ${COLORS.GREY_T_60} !important;
    line-height: 1.5715;
    cursor: pointer;
    transition: all 0.3s, visibility 0s;
  }

  @media only screen and (max-device-width: 767px) {
    .ant-collapse-content > .ant-collapse-content-box {
      padding: 0px !important;
  }
  }
  @media only screen and (min-width: 768px )  and  (max-width : 1200px){
    .ant-collapse-content > .ant-collapse-content-box {
      padding: 0px !important;
  }
  }

 
`

export const StyleLeft = styled.div`
  float:right;
  width:100%;
`
export const AnchorText = styled.a`
  font-style: normal;
  font-weight: 500;
  padding-top: 10px;
  padding-right: 25px;
  font-size: 13px;
  line-height: 18px;
  color: ${COLORS.PRIMARY};
`

export const RadioGroup = styled(Radio.Group)`
  .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled) {
    box-shadow: none !important;
    background-color: #3249d7 !important;
    color: #ffffff !important;
  }
  .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled)::before {
    background-color: #3249d7;
  }
  .ant-radio-button-wrapper:not(:first-child)::before {
    width: 0px;
  }
  .ant-radio-button-wrapper {
    position: inherit;
  }

  border: 1px #dbdbdb solid;
  padding: 2px;
  border-radius: 8px;
`
export const StyledButton = styled(Radio.Button)`
  background: #ffffff;
  font-weight: 600;
  font-size: 14px;
  color: ${COLORS.GREY_T_60} ;
  text-align: center;

  :focus-within {
    box-shadow: none !important;
    background-color: #3249d7 !important;
    color: #3249d7 !important;
  }
  .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled) {
    box-shadow: none !important;
    background-color: #3249d7 !important;
    color: #ffffff !important;
  }
  

  :first-child {
    border-radius: 6px;
    border: 0px !important;
  }
  :last-child {
    border-radius: 6px;
    border: 0px !important;
  }

  &:hover {
    :first-child {
      border: 0px !important;
    }
    :last-child {
      border: 0px !important;
    }
  }
`

export const Name1 = styled.div`
  font-weight: 600;
  font-size: 16px;
  height: 18px;
  line-height: 21px;
  color: #1b1f22;
  text-transform: capitalize;
  @media only screen and (max-device-width: 767px) {
    font-size: 10px;
    line-height: 16px;
  }
  @media only screen and (min-width: 768px )  and  (max-width : 1200px){
    font-size: 10px;
    line-height: 16px;
  }
`

export const Name = styled.div`
font-style: normal;
font-weight: 500;
font-size: 14px;
line-height: 18px;
color: #343E59;
  text-transform: capitalize;
  @media only screen and (max-device-width: 767px) {
    font-size: 10px;
    line-height: 16px;
  }
  @media only screen and (min-width: 768px )  and  (max-width : 1200px){
    font-size: 10px;
    line-height: 16px;
  }
`

export const Address = styled.div`
  font-weight: 500;
  font-size: 12px;
  line-height: 20px;
  color: #1b1f22;
  opacity: 0.48;
  @media only screen and (max-device-width: 767px) {
    font-size: 10px;
    line-height: 16px;
  }
  @media only screen and (min-width: 768px )  and  (max-width : 1200px){
    font-size: 10px;
    line-height: 16px;
  }
`

export const NameAdd = styled(Flex)`
  gap: 5px;
`
export const FullTable = styled.table`
margin: 0;
padding: 0;
width: 100%;
border-collapse: separate;
border-spacing: 0 10px;
td:last-child {
  padding-right: 10px;
}
`
export const SlRow = styled.tr`
  padding: 10px;
  height: 103px;
  border-radius: 10px !important;
  border: 1px solid #e6e7ea !important;
  box-shadow: 0px 2px 8px 8px rgba(201, 201, 201, 0.1),
    inset 0px -1px 0px rgba(0, 0, 0, 0.05);
`

export const SlCol = styled.td`
  td {
    border-radius: 10px ;
    padding: 10px;
  }
`
export const SlCol1 = styled.td`

  padding-left: 15px; 
`
export const VerticalDivider = styled(Divider)`
  height: 45px;
  padding-right: 10px;
`

export const DateText = styled.div`
  font-weight: 600;
  font-size: 14px;
  line-height: 18px;
  color: #343e59;
  padding: 15px 0px;
`
export const SingleDate = styled.div`
  font-weight: 700;
  font-size: 20px;
  line-height: 28px;
  color: #343e59;
  text-align: right;
  @media only screen and (max-device-width: 767px) {
      font-size: 14px;
  }
  @media only screen and (min-width: 768px )  and  (max-width : 1200px){
    font-size: 14px;
  }
`
export const LeftAlignCol = styled(Col)`
  padding-left: 10px;
`

export const MiniDateCal = styled(Calendar)`
  .ant-picker-content {
    border-collapse: inherit !important;
  }
  .ant-picker-calendar-mini .ant-picker-content th {
    padding: 10 !important;
  }
  td {
    border: 0px !important;
  }
  .ant-picker-cell {
    padding: 10px 0 !important;
  }
  .ant-picker-cell-in-view {
    color: #4d566e !important;
  }
  .ant-picker-cell-in-view.ant-picker-cell-selected .ant-picker-cell-inner,
  .ant-picker-cell-in-view.ant-picker-cell-range-start .ant-picker-cell-inner,
  .ant-picker-cell-in-view.ant-picker-cell-range-end .ant-picker-cell-inner {
    height: 35px !important;
    width: 35px !important;
    border-radius: 50% !important;
    justify-content: center !important;
    padding-top: 5px !important;
  }
  .ant-picker-cell-in-view.ant-picker-cell-today
    .ant-picker-cell-inner::before {
    border: 0px !important;
  }
`
export const LeftCol = styled(Col)`
  padding-left: 20px;
`
export const CenterCol = styled(Col)`
  text-align: center;
`

export const RightArrow = styled(RightOutlined)`
  cursor: pointer;
`

export const LeftArrow = styled(LeftOutlined)`
  cursor: pointer;
`
export const StyledCheckboxGroup = styled(Checkbox.Group)`

  .ant-checkbox-group-item {
    width: 90%;
    padding-top: 15px;
  }

`
export const StyledCheckbox = styled(Checkbox)`
padding-top: 10px;
  .ant-checkbox + span {
    padding-left: 12px;
  }
  .ant-checkbox-group-item {
    width: 100%;
    padding-top: 10px;
  }
  .ant-checkbox-wrapper {
    padding: 5px !important;
  }
`
export const ContentCenterDiv = styled.div`
  text-align: center;
`
export const SpinWrapper = styled(Flex)`
  padding-top: 25%;
`

export const StyledTag = styled(Tag)`
margin-left:10px;
line-height: 30px;
background: #F2F3F5;
border: 1px solid #F2F3F5;
font-weight: 600;
`